import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { subscribe, unsubscribe } from '@stepstone/events-js';
import { getSubscriptionEvents, getUpdateFunctionsCustomEvent, getUpdateFunctionsPubSub, } from './eventsSubscriptions.js';
import { closeStepModalThunk } from './stepModalSlice.js';
import { useAppDispatch, useAppSelector } from '../../hooks.js';
import { sendGlobalTrackingThunk } from '../../core/thunks.js';
import { removeDynamicGlobalTrackingLibraryScript } from '../../../tracking/tools.js';
import { trackButtonClick } from '../../../tracking/index.js';
import { stepModalNavigationMiddleware } from './stepModalNavigationMiddleware.js';
import { pageNavigationMiddleware } from '../Page/pageNavigationMiddleware.js';
import { useConsentLevelSubscriber } from '../../../helpers/useConsentLevel.js';
import { useGDPRModalActive } from '../../../helpers/useConsentLevel.js';
import { encodedGTLibraryUrlSelector, logoBrandNameSelector, } from '../../core/siteConfig/siteConfigSlice.js';
import { activeViewSelector, twoStepTrackingComponentStateSelector, } from '../../core/wrapperContext/wrapperContextSlice.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { useOptimizelyExperiment } from '../../core/experiments/useOptimizelyExperiment.js';
import { lastLoginMethodSelector } from '../../core/authSuccess/authSuccessSlice.js';
import { LastLoginMethodExperimentKey } from '../../core/experiments/allExperiments/lastLoginMethod.js';
import { StepModalComponent } from './StepModalComponent.js';
export const StepModal = () => {
    const dispatch = useAppDispatch();
    const lastLoginMethod = useAppSelector(lastLoginMethodSelector);
    const activeView = useAppSelector(activeViewSelector);
    const encodedGTLibraryUrl = useAppSelector(encodedGTLibraryUrlSelector);
    const logoBrandName = useAppSelector(logoBrandNameSelector);
    const twoStepModalComponentState = useAppSelector(twoStepTrackingComponentStateSelector);
    const lastLoginMethodVariant = useOptimizelyExperiment(LastLoginMethodExperimentKey);
    const showLastLoginMethod = lastLoginMethodVariant === 'B' && !!lastLoginMethod;
    useConsentLevelSubscriber();
    useGDPRModalActive();
    const hideModal = () => {
        if (activeView === FORM_TYPES.TWO_STEP_RESET_PASSWORD) {
            dispatch(sendGlobalTrackingThunk(trackButtonClick, {
                componentState: 'resetPasswordEnterEmailForm',
                uniqueName: 'modalClose',
            }));
        }
        else if (activeView === FORM_TYPES.TWO_STEP_RESET_PASSWORD_SUCCESS) {
            dispatch(sendGlobalTrackingThunk(trackButtonClick, {
                componentState: 'resetPasswordAttempted',
                uniqueName: 'modalClose',
            }));
        }
        else {
            dispatch(sendGlobalTrackingThunk(trackButtonClick, {
                componentState: twoStepModalComponentState,
                uniqueName: 'modalClose',
            }));
        }
        stepModalNavigationMiddleware.remove();
        pageNavigationMiddleware.resume();
        removeDynamicGlobalTrackingLibraryScript();
        dispatch(closeStepModalThunk());
    };
    const updateFunctions = getUpdateFunctionsCustomEvent(encodedGTLibraryUrl, logoBrandName, dispatch, showLastLoginMethod);
    const updateFunctionsPubSub = getUpdateFunctionsPubSub(encodedGTLibraryUrl, logoBrandName, dispatch, showLastLoginMethod);
    const eventsToSubscribe = getSubscriptionEvents({
        ...updateFunctions,
        hideModal,
    });
    const eventsToSubscribePubSub = getSubscriptionEvents({
        ...updateFunctionsPubSub,
        hideModal,
    });
    useEffect(() => {
        eventsToSubscribe.map((event) => {
            subscribe(event.eventName, event.updateFunction);
        });
        if ('PubSub' in window) {
            eventsToSubscribePubSub.map((event) => {
                window.PubSub.subscribe(event.eventName, event.updateFunction);
            });
        }
        return () => {
            eventsToSubscribe.map((event) => {
                unsubscribe(event.eventName, event.updateFunction);
            });
            if ('PubSub' in window) {
                eventsToSubscribePubSub.map((event) => {
                    window.PubSub.unsubscribe(event.eventName);
                });
            }
        };
    });
    return _jsx(StepModalComponent, { hideModal: hideModal });
};
//# sourceMappingURL=StepModal.js.map